import type { InfraStatus } from "@mc/types"
import { apiRequest } from "./httpClient.js"

/** FR section 9: banner persistente de estado de infraestructura. */
export function fetchInfraStatus(): Promise<{ infraStatus: InfraStatus | null }> {
  return apiRequest("/api/v1/infra/status")
}
